import { SINGLE_TOKEN_REGEX } from "../internal/constants";
import { resolvePath } from "../internal/resolvePath";
import { resolveConditionals } from "../internal/resolveConditionals";
import type { InterpolateParams } from "../types";

/**
 * Resolve um template single-token e coage o valor para boolean
 * (`true`/`"true"` → `true`). Retorna `false` se não for single-token
 * ou o valor não representar verdadeiro.
 */
export function extractBoolean({
  structure,
  template,
}: InterpolateParams): boolean {
  const match = resolveConditionals({ template, structure }).match(SINGLE_TOKEN_REGEX);
  if (!match) return false;

  const [, path] = match;
  const value = resolvePath(structure, path);

  return value === true || value === "true";
}
